import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import ProjectDashboard from "./components/ProjectDashboard";
import AuthenticationCheck from "./components/AuthenticationCheck";

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isMsalInitialized, setIsMsalInitialized] = useState(false);

  // Initialize MSAL on component mount
  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        setIsMsalInitialized(true);
      } catch (error) {
        console.error("MSAL initialization failed:", error);
      }
    };
    initializeMsal();
  }, []);

  if (!isMsalInitialized) {
    return <div>Loading MSAL...</div>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <AuthenticationCheck>
          <Routes>
            <Route path="/" element={<ProjectDashboard />} />
            <Route path="/dashboard" element={<ProjectDashboard />} />
            <Route path="/contacts" element={<ProjectDashboard />} />
            <Route path="/contacts/manage" element={<ProjectDashboard />} />
          </Routes>
        </AuthenticationCheck>
      </Router>
    </MsalProvider>
  );
}

export default App;